<template>
  <span class="no-style-button cookie-button">
    <i class="fi fi-rr-cookie-alt"> </i>
  </span>
</template>

<style scoped lang="scss">
@import './CookieButton.scss';
</style>
